import React from "react";
import "./NotFound.css";

export default function NotFound() {
    return (
        <div className="not-found-page">
            <h1 className="not-found-title">404</h1>
            <p className="not-found-heading">
                Oops! Page not found
            </p>
            <p className="not-found-text">
                The page you are looking for does not exist or may have been moved.
            </p>
        </div>
    );
}